import axios from 'axios';
import BaseUrl from '../util/BaseUrl';

const API_URL = BaseUrl.baseurl+"api/leads";

const getCustomerLeads = async (token) => {
    try {
        const response = await axios.get(API_URL + '/self', {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error:', error.response ? error.response.data : error.message);
        throw new Error(error.response ? error.response.data : 'Failed to get leads');
    }
};

const getLeadsByAdertisement = async (id, token) => {
    try {
        const response = await axios.get(API_URL +'/advertisement/'+id, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error:', error.response ? error.response.data : error.message);
        throw new Error(error.response ? error.response.data : 'Failed to get leads');
    }
};

const createLead = async (lead) => {
    try {
        const response = await axios.post(`${API_URL}/create`, lead, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : 'Failed to create lead');       
    }
};

const LeadsService = {
    getCustomerLeads,
    getLeadsByAdertisement,
    createLead
};

export default LeadsService;
